"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tapis Systems API
 * The Tapis Systems API provides for management of Tapis Systems including permissions, credentials and Scheduler Profiles.
 *
 * The version of the OpenAPI document: 1.0.0-rc1
 * Contact: cicsupport@tacc.utexas.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
function TapisSystemFromJSON(json) {
    return TapisSystemFromJSONTyped(json, false);
}
exports.TapisSystemFromJSON = TapisSystemFromJSON;
function TapisSystemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tenant': !runtime_1.exists(json, 'tenant') ? undefined : json['tenant'],
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'description': !runtime_1.exists(json, 'description') ? undefined : json['description'],
        'systemType': !runtime_1.exists(json, 'systemType') ? undefined : _1.SystemTypeEnumFromJSON(json['systemType']),
        'owner': !runtime_1.exists(json, 'owner') ? undefined : json['owner'],
        'host': !runtime_1.exists(json, 'host') ? undefined : json['host'],
        'enabled': !runtime_1.exists(json, 'enabled') ? undefined : json['enabled'],
        'effectiveUserId': !runtime_1.exists(json, 'effectiveUserId') ? undefined : json['effectiveUserId'],
        'defaultAuthnMethod': !runtime_1.exists(json, 'defaultAuthnMethod') ? undefined : _1.AuthnEnumFromJSON(json['defaultAuthnMethod']),
        'authnCredential': !runtime_1.exists(json, 'authnCredential') ? undefined : _1.CredentialFromJSON(json['authnCredential']),
        'bucketName': !runtime_1.exists(json, 'bucketName') ? undefined : json['bucketName'],
        'rootDir': !runtime_1.exists(json, 'rootDir') ? undefined : json['rootDir'],
        'port': !runtime_1.exists(json, 'port') ? undefined : json['port'],
        'useProxy': !runtime_1.exists(json, 'useProxy') ? undefined : json['useProxy'],
        'proxyHost': !runtime_1.exists(json, 'proxyHost') ? undefined : json['proxyHost'],
        'proxyPort': !runtime_1.exists(json, 'proxyPort') ? undefined : json['proxyPort'],
        'dtnSystemId': !runtime_1.exists(json, 'dtnSystemId') ? undefined : json['dtnSystemId'],
        'dtnMountPoint': !runtime_1.exists(json, 'dtnMountPoint') ? undefined : json['dtnMountPoint'],
        'dtnMountSourcePath': !runtime_1.exists(json, 'dtnMountSourcePath') ? undefined : json['dtnMountSourcePath'],
        'isDtn': !runtime_1.exists(json, 'isDtn') ? undefined : json['isDtn'],
        'canExec': !runtime_1.exists(json, 'canExec') ? undefined : json['canExec'],
        'canRunBatch': !runtime_1.exists(json, 'canRunBatch') ? undefined : json['canRunBatch'],
        'jobRuntimes': !runtime_1.exists(json, 'jobRuntimes') ? undefined : (new Set(json['jobRuntimes'].map(_1.JobRuntimeFromJSON))),
        'jobWorkingDir': !runtime_1.exists(json, 'jobWorkingDir') ? undefined : json['jobWorkingDir'],
        'jobEnvVariables': !runtime_1.exists(json, 'jobEnvVariables') ? undefined : (json['jobEnvVariables'].map(_1.KeyValuePairFromJSON)),
        'jobMaxJobs': !runtime_1.exists(json, 'jobMaxJobs') ? undefined : json['jobMaxJobs'],
        'jobMaxJobsPerUser': !runtime_1.exists(json, 'jobMaxJobsPerUser') ? undefined : json['jobMaxJobsPerUser'],
        'batchScheduler': !runtime_1.exists(json, 'batchScheduler') ? undefined : _1.SchedulerTypeEnumFromJSON(json['batchScheduler']),
        'batchLogicalQueues': !runtime_1.exists(json, 'batchLogicalQueues') ? undefined : (json['batchLogicalQueues'].map(_1.LogicalQueueFromJSON)),
        'batchDefaultLogicalQueue': !runtime_1.exists(json, 'batchDefaultLogicalQueue') ? undefined : json['batchDefaultLogicalQueue'],
        'batchSchedulerProfile': !runtime_1.exists(json, 'batchSchedulerProfile') ? undefined : json['batchSchedulerProfile'],
        'jobCapabilities': !runtime_1.exists(json, 'jobCapabilities') ? undefined : (json['jobCapabilities'].map(_1.CapabilityFromJSON)),
        'tags': !runtime_1.exists(json, 'tags') ? undefined : json['tags'],
        'notes': !runtime_1.exists(json, 'notes') ? undefined : json['notes'],
        'importRefId': !runtime_1.exists(json, 'importRefId') ? undefined : json['importRefId'],
        'uuid': !runtime_1.exists(json, 'uuid') ? undefined : json['uuid'],
        'deleted': !runtime_1.exists(json, 'deleted') ? undefined : json['deleted'],
        'created': !runtime_1.exists(json, 'created') ? undefined : json['created'],
        'updated': !runtime_1.exists(json, 'updated') ? undefined : json['updated'],
    };
}
exports.TapisSystemFromJSONTyped = TapisSystemFromJSONTyped;
function TapisSystemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tenant': value.tenant,
        'id': value.id,
        'description': value.description,
        'systemType': _1.SystemTypeEnumToJSON(value.systemType),
        'owner': value.owner,
        'host': value.host,
        'enabled': value.enabled,
        'effectiveUserId': value.effectiveUserId,
        'defaultAuthnMethod': _1.AuthnEnumToJSON(value.defaultAuthnMethod),
        'authnCredential': _1.CredentialToJSON(value.authnCredential),
        'bucketName': value.bucketName,
        'rootDir': value.rootDir,
        'port': value.port,
        'useProxy': value.useProxy,
        'proxyHost': value.proxyHost,
        'proxyPort': value.proxyPort,
        'dtnSystemId': value.dtnSystemId,
        'dtnMountPoint': value.dtnMountPoint,
        'dtnMountSourcePath': value.dtnMountSourcePath,
        'isDtn': value.isDtn,
        'canExec': value.canExec,
        'canRunBatch': value.canRunBatch,
        'jobRuntimes': value.jobRuntimes === undefined ? undefined : (Array.from(value.jobRuntimes).map(_1.JobRuntimeToJSON)),
        'jobWorkingDir': value.jobWorkingDir,
        'jobEnvVariables': value.jobEnvVariables === undefined ? undefined : (value.jobEnvVariables.map(_1.KeyValuePairToJSON)),
        'jobMaxJobs': value.jobMaxJobs,
        'jobMaxJobsPerUser': value.jobMaxJobsPerUser,
        'batchScheduler': _1.SchedulerTypeEnumToJSON(value.batchScheduler),
        'batchLogicalQueues': value.batchLogicalQueues === undefined ? undefined : (value.batchLogicalQueues.map(_1.LogicalQueueToJSON)),
        'batchDefaultLogicalQueue': value.batchDefaultLogicalQueue,
        'batchSchedulerProfile': value.batchSchedulerProfile,
        'jobCapabilities': value.jobCapabilities === undefined ? undefined : (value.jobCapabilities.map(_1.CapabilityToJSON)),
        'tags': value.tags,
        'notes': value.notes,
        'importRefId': value.importRefId,
        'uuid': value.uuid,
        'deleted': value.deleted,
        'created': value.created,
        'updated': value.updated,
    };
}
exports.TapisSystemToJSON = TapisSystemToJSON;
